import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

function App() {
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
        <div className="container">
          <a className="navbar-brand fw-bold" href="/">BEON</a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <a className="nav-link" href="#home">
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#features">
                  Features
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#faq">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <section className="hero text-center text-white d-flex align-items-center" id="home">
        <div className="container py-5"
          style={{
            width: "25%",
            background: "rgba(0,0,0,0.35)",
            borderRadius: "16px",
            backdropFilter: "blur(1px)", // optional, adds glass effect
          }}>
          <h1 className="display-4 fw-bold">BEON</h1>
          <div className="d-flex gap-4 justify-content-center">

            {/* Instagram Icon Button */}
            <a
              href="https://www.instagram.com/ramo_r.o.e/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-light btn-lg d-flex align-items-center justify-content-center"
              style={{ width: "60px", height: "60px", borderRadius: "50%" }}
            >
              <ion-icon name="logo-instagram" style={{ fontSize: "32px" }}></ion-icon>
            </a>

            {/* SoundCloud Icon Button */}
            <a
              href="https://on.soundcloud.com/ST8CXIvjPITfTQFf43"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-light btn-lg d-flex align-items-center justify-content-center"
              style={{ width: "60px", height: "60px", borderRadius: "50%" }}
            >
              <ion-icon name="musical-notes-outline" style={{ fontSize: "32px" }}></ion-icon>
            </a>

          </div>
        </div>
      </section>


      <footer className="bg-light py-4 text-center">
        <div className="container">
          <p className="mb-0 text-muted">
            © {new Date().getFullYear()} BEON. All rights reserved.
          </p>
        </div>
      </footer>
    </>
  );
}

export default App;
